export default function Trajes(){
    return(
        <div>
            <div className="container mt-5">
                <div className="col-12 col-md-12 col-lg-12 col-xl-12">
                    <h1 className="titulo text-center">
                        CADA MISIÓN, UN TRAJE DIFERENTE
                    </h1>
                </div>
            </div>

            <hr></hr>

            <div className="trajes">
                <div className="container">
                    <div className="row">
                        <div className="col-12 col-mb-12 col-lg-12 col-xl-12">
                            <div class="card mb-3 bg-dark">
                                <div class="row g-0">
                                    <div class="col-md-4">
                                        <img src="/imagenes/batman-1939.jpg" class="img-fluid" alt="batman-1939"></img>
                                    </div>
                                    <div class="col-md-8">
                                        <div class="card-body text-white">
                                            <h3 class="card-title titulo">
                                                TRAJE CLÁSICO
                                            </h3>
                                            <hr className="gold w-50"></hr>
                                            <p>
                                                <strong>Primera aparición: </strong>
                                                Detective Comics #27 (1939)<br></br>
                                            </p>
                                            <p class="card-text">
                                                Su diseño incluía un traje gris, capa y
                                                capucha negras, guantes morados y un
                                                cinturón utilitario amarillo para guardar
                                                gadgets. El símbolo del murciélago en el
                                                pecho era pequeño y simple, sin el óvalo
                                                amarillo que aparecería en versiones
                                                posteriores. Este primer diseño, creado
                                                por Bob Kane y Bill Finger, estableció la
                                                base del aspecto clásico del héroe y
                                                reflejaba su estilo de vigilante oscuro
                                                que protegía Ciudad Gótica.
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="container mt-5">
                    <div className="row">
                        <div className="col-12 col-mb-12 col-lg-12 col-xl-12">
                            <div class="card mb-3 bg-dark">
                                <div class="row g-0">
                                    <div class="col-md-4">
                                        <img src="/imagenes/batman-1964.jpg" class="img-fluid" alt="batman-1964"></img>
                                    </div>
                                    <div class="col-md-8">
                                        <div class="card-body text-white">
                                            <h3 class="card-title titulo">
                                                TRAJE CON ÓVALO AMARILLO
                                            </h3>
                                            <hr className="gold w-50"></hr>
                                            <p>
                                                <strong>Primera aparición: </strong>
                                                Detective Comics #327 (1964)<br></br>
                                            </p>
                                            <p class="card-text">
                                                Este traje introdujo el famoso óvalo 
                                                amarillo alrededor del símbolo del 
                                                murciélago, un cambio visual 
                                                importante en el diseño de Batman. 
                                                El objetivo era hacer el emblema más 
                                                visible en las portadas y paneles del 
                                                cómic. Con el tiempo, este diseño se 
                                                convirtió en uno de los más icónicos 
                                                del personaje y fue utilizado durante 
                                                varias décadas en cómics, series 
                                                animadas y adaptaciones.
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="container mt-5">
                    <div className="row">
                        <div className="col-12 col-mb-12 col-lg-12 col-xl-12">
                            <div class="card mb-3 bg-dark">
                                <div class="row g-0">
                                    <div class="col-md-4">
                                        <img src="/imagenes/batman-tdkr.jpg" class="img-fluid" alt="batman-tdkr"></img>
                                    </div>
                                    <div class="col-md-8">
                                        <div class="card-body text-white">
                                            <h3 class="card-title titulo">
                                                THE DARK KNIGHT RETURNS
                                            </h3>
                                            <hr className="gold w-50"></hr>
                                            <p>
                                                <strong>Primera aparición: </strong>
                                                The Dark Knight Returns (1986)<br></br>
                                            </p>
                                            <p class="card-text">
                                                Este traje aparece en la historia The 
                                                Dark Knight Returns, donde Bruce Wayne 
                                                vuelve a convertirse en Batman después 
                                                de años retirado. A diferencia de 
                                                versiones anteriores, el diseño 
                                                muestra un traje más pesado y simple, 
                                                con un gran símbolo negro del 
                                                murciélago que ocupa gran parte del 
                                                pecho y sin el óvalo amarillo clásico. 
                                                El aspecto del traje transmite la idea 
                                                de un Batman más veterano y brutal, 
                                                que depende más de su fuerza, 
                                                experiencia y estrategia que de la 
                                                agilidad. Este diseño se volvió muy 
                                                influyente y cambió la forma en que 
                                                el personaje fue representado en 
                                                cómics posteriores y otras 
                                                adaptaciones.
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="container mt-5">
                    <div className="row">
                        <div className="col-12 col-mb-12 col-lg-12 col-xl-12">
                            <div class="card mb-3 bg-dark">
                                <div class="row g-0">
                                    <div class="col-md-4">
                                        <img src="/imagenes/batman-tdkr-2.jpg" class="img-fluid" alt="batman-tdkr-2"></img>
                                    </div>
                                    <div class="col-md-8">
                                        <div class="card-body text-white">
                                            <h3 class="card-title titulo">
                                                ARMORED BATSUIT
                                            </h3>
                                            <hr className="gold w-50"></hr>
                                            <p>
                                                <strong>Primera aparición: </strong>
                                                The Dark Knight Returns (1986)<br></br>
                                            </p>
                                            <p class="card-text">
                                                En la historia The Dark Knight Returns, 
                                                Batman utiliza esta armadura como parte 
                                                de un plan cuidadosamente preparado para 
                                                enfrentarse a Superman. Gracias a la 
                                                protección adicional y a su estrategia, 
                                                logra resistir varios ataques y mantenerse 
                                                en la pelea contra un rival con habilidades 
                                                sobrehumanas. La armadura no solo le brinda 
                                                mayor resistencia, sino que también le 
                                                permite soportar impactos mucho más fuertes 
                                                de lo que su traje normal permitiría. Este 
                                                traje se convirtió en uno de los 
                                                diseños más recordados del personaje, 
                                                ya que representa perfectamente la 
                                                idea de Batman como un estratega que 
                                                puede enfrentarse incluso a seres 
                                                mucho más poderosos que él.
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="container mt-5">
                    <div className="row">
                        <div className="col-12 col-mb-12 col-lg-12 col-xl-12">
                            <div class="card mb-3 bg-dark">
                                <div class="row g-0">
                                    <div class="col-md-4">
                                        <img src="/imagenes/batman-1989.jpg" class="img-fluid" alt="batman-1989"></img>
                                    </div>
                                    <div class="col-md-8">
                                        <div class="card-body text-white">
                                            <h3 class="card-title titulo">
                                                BATMAN (1989)
                                            </h3>
                                            <hr className="gold w-50"></hr>
                                            <p>
                                                <strong>Primera aparición: </strong>
                                                Batman (1989)<br></br>
                                            </p>
                                            <p class="card-text">
                                                Este traje fue uno de los primeros en 
                                                mostrar a Batman con un diseño 
                                                completamente negro, dándole una 
                                                apariencia mucho más oscura y 
                                                amenazante que en versiones 
                                                anteriores. El traje está hecho de 
                                                armadura de goma que protege el 
                                                cuerpo y le da un aspecto más robusto.
                                            </p>
                                            <p>
                                                La versión interpretada por Michael 
                                                Keaton ayudó a redefinir al personaje 
                                                en el cine, alejándolo del estilo más 
                                                colorido de adaptaciones antiguas y 
                                                presentándolo como un héroe más serio 
                                                y misterioso. Este diseño se volvió 
                                                muy influyente y marcó el tono de 
                                                muchas adaptaciones posteriores 
                                                del personaje.
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="container mt-5">
                    <div className="row">
                        <div className="col-12 col-mb-12 col-lg-12 col-xl-12">
                            <div class="card mb-3 bg-dark">
                                <div class="row g-0">
                                    <div class="col-md-4">
                                        <img src="/imagenes/batman-new52.jpg" class="img-fluid" alt="batman-new52"></img>
                                    </div>
                                    <div class="col-md-8">
                                        <div class="card-body text-white">
                                            <h3 class="card-title titulo">
                                                THE NEW 52
                                            </h3>
                                            <hr className="gold w-50"></hr>
                                            <p>
                                                <strong>Primera aparición: </strong>
                                                Justice League #1 (The New 52) (2011)<br></br>
                                            </p>
                                            <p class="card-text">
                                                Este traje apareció durante el relanzamiento 
                                                editorial conocido como The New 52, donde Batman 
                                                recibe un diseño más moderno. A diferencia de trajes 
                                                posteriores que estaban hechos de tela, este incluía 
                                                placas de armadura y detalles tecnológicos, lo que 
                                                le proporciona una mayor protección en combate.
                                            </p>
                                            <p>
                                                El traje mantiene detalles clásicos como la capa negra, 
                                                el traje gris oscuro y el cinturón utilitario, pero 
                                                con un diseño más táctico y estilizado. Este traje ayudó 
                                                a actualizar visualmente al personaje para una nueva 
                                                generación de lectores.
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}